<template>
  <div v-scroll-to="'#header'" class="scroller" :class="{ 'scroller--hidden': !isVisible }">
    <unicon name="arrow-up" height="40" width="40" class="scroller__arrow"></unicon>
  </div>
</template>

<script>
export default {
  data: () => ({
    windowHeight: window.innerHeight,
    isVisible: false,
  }),
  created() {
    this.setScrollEventListener();
  },
  methods: {
    setScrollEventListener() {
      window.addEventListener(
        "scroll",
        this.scrollerVisibilityHandler.bind(this)
      );
    },
    scrollerVisibilityHandler() {
      const { scrollY } = window;
      if (scrollY > this.windowHeight / 2) {
        this.isVisible = true;
      } else {
        this.isVisible = false;
      }
    }
  }
};
</script>